import { useState } from "react";

import RateCatalogForm from "./RateCatalogForm"; 
import RateCatalogList from "./RateCatalogList";

const RateCatalog = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  
  
  const [upData, setUpData] = useState(false);


  return (
    <>
      {fromIsShown ? ( 

        <RateCatalogForm addForm={setFromIsShown} update={upData} /> 
        
      ) : (
        <RateCatalogList addForm={setFromIsShown} update={setUpData} />
      )}
    </>
  );
};
export default RateCatalog;
